import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL veya Anon Key bulunamadı!');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tip tanımlamaları
export interface SiteSettings {
  id: string;
  site_name: string;
  logo_url?: string;
  phone: string;
  whatsapp: string;
  email: string;
  address: string;
  footer_text?: string;
  created_at: string;
  updated_at: string;
}

export interface Service {
  id: string;
  title: string;
  slug: string;
  description?: string;
  icon?: string;
  image_url?: string;
  order_index: number;
  is_active: boolean;
  seo_title?: string;
  seo_description?: string;
  created_at: string;
  updated_at: string;
}

export interface Brand {
  id: string;
  name: string;
  slug: string;
  logo_url?: string;
  description?: string;
  order_index: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  phone?: string;
  service?: string;
  message?: string;
  is_read: boolean;
  created_at: string;
}
